import { DASHBOARD_ENABLED } from "@/constants";

const withDashboard = <P extends object>(
  Component: React.ComponentType<P>
): React.FC<P> => {
  return function WithBrandComponent(props: P) {
    const dashboardEnabled = DASHBOARD_ENABLED;
    return (
      <Component
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        dashboardEnabled={dashboardEnabled === "true" || false}
      />
    );
  };
};

export default withDashboard;
